import dedent from 'dedent';
import { z } from 'zod';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, zodTDateISODate } from '~/lib/zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';

export type BookletSide = z.infer<typeof sideSchema>;

export type BookletCount = z.infer<typeof countSchema>;

export type BookletPaper = z.infer<typeof paperSchema>;

export const sideSchema = z.enum([
  '8',
  '12',
  '16',
  '20',
  '24',
  '28',
  '32'
]);

export const countSchema = z.enum([
  '50',
  '100',
  '150',
  '200',
]);

export const paperSchema = z.enum([
  'low_gloss',
  'heavy_gloss',
]);

export default createPerformableConfig(
  'booklets',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      sides: sideSchema,
      count: countSchema,
      paper: paperSchema,
      need_by: zodTDateISODate('Need By date is required'),
      no_free_uv: coerceBoolean().optional(),
      content_writing: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Luxury Booklets',
    group: 'Property Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/booklets/thumbnail_v4.jpg',
    images: [],
    short: dedent`
      Our luxury 8.5" x 8.5" real estate booklets come in 4 to 24 sides on heavy or super \
      heavy gloss paper, with an optional UV gloss coating for a polished finish. Printed \
      in increments of 50, they elegantly showcase properties with rich imagery and details. \
      Need content? Our writers can help for a small fee.
    `,
  },
);
